// extracted by mini-css-extract-plugin
module.exports = {"tableAction":"TableAction_tableAction__1uuNL"};